import { jsx as _jsx } from "react/jsx-runtime";
function BadgeCheck({ className, size = 24 }) {
    return (_jsx("svg", { className: className, height: size, width: size, fill: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.4198 1H2.58035L2.5805 17.4385L12.0002 22.877L21.4199 17.4385L21.4198 1ZM10.9504 14.3042L16.6004 8.65422L15.2004 7.20422L10.9504 11.4542L8.80039 9.35422L7.40039 10.7542L10.9504 14.3042Z" }) }));
}
export default BadgeCheck;
